import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/parametres',                 label: 'Société' },
  { to: '/parametres/modeles',         label: 'Modèles de facture' },
  { to: '/parametres/numerotation',    label: 'Numérotation' },
  { to: '/parametres/plan',            label: 'Plan & facturation' },
  { to: '/parametres/security',        label: 'Sécurité (2FA)' },
  { to: '/parametres/signature',       label: 'Signature PDF' },
  { to: '/parametres/api-keys',        label: 'Clés API' },
  { to: '/parametres/webhooks',        label: 'Webhooks' },
  { to: '/parametres/audit',           label: "Journal d'audit" },
  { to: '/parametres/gdpr',            label: 'RGPD' },
];

const ParametresLayout: React.FC = () => (
  <div className="space-y-6">
    <h1 className="text-2xl font-bold text-gray-900">Paramètres</h1>
    <nav className="flex gap-1 flex-wrap border-b border-gray-200">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.to === '/parametres'}
          className={({ isActive }) =>
            `px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              isActive
                ? 'border-blue-600 text-blue-700'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
    <Outlet />
  </div>
);

export default ParametresLayout;
